const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Contactos y Servicios",
  description:
    "Bienvenido al Area de Servicio de BRIDGESTONE PLUS. Aqui puedes encontrar los detalles de los contactos del equipo de ventas.",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Equipo comercio de neumáticos",
    car: "Equipo concesionarios",
    lkw: "Equipo camiones",
    em_otr: "Equipo EM/OTR",
    farm_tractor: "Equipo tractores agrícolas",
    bandag: "Equipo Bandag",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
